<template>
    <div class="exam-wrap">
        <div class="box2">
            <div class="header_i">
                <div class="h_left">
                    <div class="h_img">
                        <img src="https://www.yitku.com/mock/account_7.png">
                    </div>
                    <div class="h_text">
                        <div class="h_txt">姓名：XXX</div>
                        <div class="h_txt">性别：X</div>
                        <div class="h_txt">准考证号：1111111111</div>
                        <div class="h_txt">证件号码：1111111111</div>
                    </div>
                </div>
                <div class="h_right">
                    <img src="https://www.yitku.com/mock/account_4.png">
                    倒计时: 00:00:{{ countdownTime }}
                </div>
            </div>
            <div class="big_title">全国会计专业技术初级资格考试重要提示</div>
            <div class="big_notice">
                <div style="width:100%;height:529px;overflow:auto; ">
                    <div v-if="showType == 1" class="ksxz_contain" id="kaowu" style="text-align: left; color: black;">
                        <div style="text-align:center; font-size:18.0pt;font-family:华文中宋;color:black;">
                            <b>全国会计专业技术初级资格考试<br>考生须知</b>
                        </div>
                        <div style="text-align:left;font-size:12pt; ">
                            <p><b>第一条</b> 考试开始前30
                                分钟，考生凭本人准考证和有效居民身份证（香港、澳门、台湾籍考生凭有效身份证明，外籍人员凭有效护照，下同）进入考场，完成电子签到后，按照监考人员指定的位置入座，并将准考证和有效居民身份证放置在桌面右上角。
                            </p>
                            <p><b>第二条</b>
                                考生进入考场时，应将准考证和有效居民身份证之外的其他物品(手机、智能手表、智能眼镜等电子设备应设置成关闭状态）存放在考场指定位置。携带准考证和有效居民身份证之外的物品（含电子、通讯、计算、存储等设备）进入考位，按违纪进行处理。
                            </p>
                            <p><b>第三条</b>
                                考生在完成签到后不得随意离开考场，如确有特殊情况需要暂时离开考场，必须经监考人员同意并由指定的监考人员陪同，凭本人有效居民身份证出入考场。考生在考试中途暂离考场，其离场时间计入本人的考试时间。
                            </p>
                            <p><b>第四条</b> 考场为考生统一提供演算纸笔。考试结束后，演算纸笔由监考人员统一收回，考生不得带出考场，违者按违纪进行处理。</p>
                            <p><b>第五条</b> 考生入座后，在登录界面输入准考证号和居民身份证号登录考试系统，认真核对屏幕显示的本人相关信息，阅读并遵守《考生须知》及《操作说明》，等待考试开始。</p>
                            <p><b>第六条</b> 考试时间以考试系统计时器为准。考试开始30分钟后，未签到的考生视为缺考，考试系统不再接受考生的登录。</p>
                            <p><b>第七条</b> 进入考场后，考生应自觉遵守考场规定，维护考场秩序，尊重并自觉接受监考人员的监督和检查，保持考场安静，遇到问题应当举手示意。</p>
                            <p><b>第八条</b>
                                考试过程中，如机器设备、网络、电力出现异常情况，考生应及时举手示意，请监考人员协调解决，不得自行处置，严禁自行关闭或重启考试机。因机器设备故障等客观原因导致答题时间出现损失，考生可以当场向监考人员提出补时要求，由监考人员根据有关规定予以处理。考试结束后，不再受理考生未当场提出的补时要求。
                            </p>
                            <p><b>第九条</b> 考试开始90分钟后，考生方可交卷离开考场。考生交卷后应当立即自行离开考场，严禁关闭考试机，不得在考场附近逗留、交谈或喧哗。</p>
                            <p><b>第十条</b> 考试时间到，考试系统将自动为所有未交卷的考生统一交卷。</p>
                            <p><b>第十一条</b> 考试期间，考生应按照考试系统要求进行操作，由于进行与考试无关的操作所造成的一切后果，由考生本人负责。</p>
                            <p><b>第十二条</b>
                                考试期间违纪违规，依据《专业技术人员资格考试违纪违规行为处理规定》（人社部令第31号）进行处理。有严重和特别严重违纪违规行为的考生，将被记入会计资格考试诚信档案库，有关信息将向社会公告，并通知当事人所在单位，相关记录也将纳入全国信用共享平台。
                            </p>
                        </div>
                    </div>
                    <div v-if="showType == 0" class="ksxz_contain" id="caozuo" style="text-align: left; color: black;">
                        <meta http-equiv="Content-Type" content="text/html; charset=gb2312">
                        <meta name="Generator" content="Microsoft Word 15 (filtered)">
                        <div align="center">
                            <img alt="" src="https://www.yitku.com/mock/001.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/002.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/003.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/004.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/006.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/007.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/008.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/009.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/010.jpg?v=11" width="800">
                            <br>
                            <img alt="" src="https://www.yitku.com/mock/011.jpg?v=11" width="758">
                        </div>
                    </div>
                </div>

                <!-- <div class="n_title">全国会计专业技术初级资格考试</div>
                <div class="n_title">考生须知</div>
                <div class="n_desc">
                    <strong>第一条</strong>
                    考试开始前30分钟，考生凭本人准考证和有效居民身份证(香港、澳门、台湾籍考生凭有效身份证明，外籍人员凭有效护照，下同)进入考场，完成电子签到后，按照监考人员指定的位置入座，并将准考证和有效居民身份证放置在桌面右上角。
                </div>
                <div class="n_desc">
                    <strong>第二条</strong>
                    考生进入考场时，应将准考证和有效居民身份证之外的其他物品(手机、智能手表，智能眼镜等电子设备应设置成关闭状态)存放在考场指定位置。携带准考证和有效居民身份证之外的物品(含电子、通讯、计算、存储等设备)进入考位，按违纪进行处理。
                </div>
                <div class="n_desc">
                    <strong>第三条</strong>
                    考生在完成签到后不得随意离开考场，如确有特殊情况需要暂时离开考场，必须经监考人员同意并由指定的监考人员陪同，凭本人有效居民身份证出入考场，考生在考试中途暂离考场，其离场时间计入本人的考试时间.
                </div>
                <div class="n_desc">
                    <strong>第四条</strong> 考场为考生统一提供演望纸笔。考试结束后，演算纸笔由监考人员统一收问，考生不得带出考场，违者按违纪进行处理，
                </div>
                <div class="n_desc">
                    <strong>第五条</strong> 考生入座后，在登录界面输入准考证号和居民身份证号登录考试系统，认真核对屏幕显示的本人相关信息，阅读并造守<<考生须知>>及<<操作说明>>，等待考试开始。
                </div> -->
                <div class="n_btns">
                    <div class="n_b_1" @click="changeType(1)">考生须知</div>
                    <div class="n_b_1" @click="changeType(0)">操作说明</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false,
            number: '11111111111',
            idcard: '11111111111',
            countdownTime: 6,
            showType: 1,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
        // 启动倒计时定时器
        let timer = setInterval(() => {
            this.countdownTime--;
            //$btn.text(`${time}秒后重新获取`);
            // 倒计时结束处理
            if (this.countdownTime <= 0) {
                clearInterval(timer); // 清除定时器
                //this.$router.push("/guide/account/question");
                this.$router.push({
                    path: "/guide/account/question",
                    query: {
                        paper_id: this.paper_id,
                    },
                });
            }
        }, 1000); // 1秒执行一次
    },
    methods: {

        changeType(type) {
            console.log(type);
            this.showType = type;
        },

        login() {
            if (this.number == '') {
                this.$message.warning("准考证号不能为空");
                return false;
            }
            if (this.idcard == '') {
                this.$message.warning("证件号码不能为空");
                return false;
            }
            this.dialogVisible = true;
        },
        goNotice() {
            this.$router.push({
                path: "/guide/account/index",
                query: {
                    paper_id: this.paper_id,
                },
            });
        },
    },
};
</script>

<style scoped>
.exam-wrap {
    background: linear-gradient(0deg, #F5F8FD 0%, #ADCFE8 100%) !important;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    overflow: hidden;
    flex-direction: column;
}

.box2 {
    width: 1200px;
    margin: 0 auto;
}

.box2 .header_i {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 4% 0 0 0;
}

.box2 .header_i .h_left {
    width: 70%;
    display: flex;
    flex-direction: row;
}

.box2 .header_i .h_left .h_img {
    width: 104px;
    height: 130px;
    margin-right: 10px;
}

.box2 .header_i .h_left .h_img img {
    width: 104px;
    height: 130px;
}

.box2 .header_i .h_left .h_text {
    display: flex;
    flex-direction: column;
}

.box2 .header_i .h_left .h_txt {
    line-height: 32px;
    font-size: 14px;
    color: #0057ED;
}

.box2 .header_i .h_right {
    width: 314px;
    height: 48px;
    line-height: 48px;
    background: linear-gradient(0deg, #F3DA41 0%, #F9FBED 100%);
    border-radius: 3px;
    border: 1px solid #BBAF37;
    display: flex;
    align-items: center;
    padding: 0 10px;
}

.box2 .header_i .h_right img {
    width: 30px;
    height: 30px;
    margin-right: 5px;
}

.box2 .big_title {
    font-weight: 1000;
    font-size: 36px;
    color: #0753A4;
    line-height: 60px;
    background: linear-gradient(180deg, #F9A252 0%, #C46204 100%);
    -webkit-text-stroke: 1px #FFFFFF;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: 100%;
    text-align: center;
    margin: 20px 0;
}

.box2 .big_notice {
    width: 96%;
    padding: 2%;
    background: #FFFFFF;
    border-radius: 10px;
}


.box2 .big_notice p {
    color: #000000;
    line-height: 30px;
    margin-bottom: 20px;
    margin-top: 20px;
}

.box2 .n_btns {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
}

.box2 .n_btns .n_b_1 {
    width: 146px;
    height: 40px;
    background: #FCA32F;
    margin: 0 10px;
    border-radius: 5px;
    line-height: 40px;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
}
</style>